import ZpModal from './src/page-modal.vue'
export default ZpModal
